import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { WorkflowEmailTemplate } from '../../types/generated.types';

@Injectable({ providedIn: 'root' })
export class WorkflowEmailTemplatesApiService extends BaseApiService {
  protected get baseUrl(): string {
    return `${super.baseUrl}/workflow-email-templates`;
  }

  async getWorkflowEmailTemplates(): Promise<WorkflowEmailTemplate[]> {
    return await this.get<WorkflowEmailTemplate[]>('');
  }

  async getWorkflowEmailTemplate(id: string): Promise<WorkflowEmailTemplate> {
    return await this.get<WorkflowEmailTemplate>(id);
  }

  async createWorkflowEmailTemplate(workflowEmailTemplate: WorkflowEmailTemplate): Promise<string> {
    return await this.postWithResult<WorkflowEmailTemplate, string>('', workflowEmailTemplate);
  }

  async updateWorkflowEmailTemplate(workflowEmailTemplate: WorkflowEmailTemplate): Promise<void> {
    return await this.put<WorkflowEmailTemplate>('', workflowEmailTemplate);
  }

  async deleteWorkflowEmailTemplate(id: string): Promise<void> {
    return await this.delete(id);
  }
}